import { Route } from "src/types/navigation/routing";
import {
  Error404,
  GenericError,
  LandingPV,
  PaymentFailure,
  PaymentSuccess,
  PolicyConfiguration,
  ProductsLadingWrapper,
} from "src/ui/pages";
import { Accessibility } from "src/ui/pages/accessibility/accessibility";
import { CookiePolicy } from "src/ui/pages/cookie-policy/cookie-policy";
import { ProgressProvider } from "src/ui/pages/policy-configuration/sections/progress-provider/progress-provider";
import { ProductsCodeMap } from "src/ui/pages/products/products_mapping.utils";

export const Paths = {
  Landing: "/",
  ProductLandingRC: "/prodotti/responsabilita-civile",
  ProductLandingTL: "/prodotti/tutela-legale",
  ProductLandingUS: "/prodotti/uffici-e-studi",
  Error404: "*",
  Accessibility: "/accessibilita",
  PolicyConfiguration: "/configurazione-polizza",
  PaymentSuccess: "/esito-pagamento-ok",
  PaymentFailure: "/esito-pagamento-ko",
  GenericError: "/errore",
  CookiePolicy: "/cookie-policy",
};

export const Routes: Record<keyof typeof Paths, Route> = {
  Landing: {
    path: Paths.Landing,
    element: (
      <ProgressProvider>
        <LandingPV />
      </ProgressProvider>
    ),
    private: true,
  },
  ProductLandingRC: {
    path: Paths.ProductLandingRC,
    element: (
      <ProgressProvider>
        <ProductsLadingWrapper codProd={ProductsCodeMap.RC01} />
      </ProgressProvider>
    ),
    private: true,
  },
  ProductLandingTL: {
    path: Paths.ProductLandingTL,
    element: (
      <ProgressProvider>
        <ProductsLadingWrapper codProd={ProductsCodeMap.TL01} />
      </ProgressProvider>
    ),
    private: true,
  },
  ProductLandingUS: {
    path: Paths.ProductLandingUS,
    element: (
      <ProgressProvider>
        <ProductsLadingWrapper codProd={ProductsCodeMap.US01} />
      </ProgressProvider>
    ),
    private: true,
  },
  Error404: {
    path: Paths.Error404,
    element: <Error404 />,
  },
  Accessibility: {
    path: Paths.Accessibility,
    element: <Accessibility />,
  },
  CookiePolicy: {
    path: Paths.CookiePolicy,
    element: <CookiePolicy />,
  },
  PolicyConfiguration: {
    path: Paths.PolicyConfiguration,
    element: (
      <ProgressProvider>
        <PolicyConfiguration />
      </ProgressProvider>
    ),
  },
  PaymentSuccess: {
    path: Paths.PaymentSuccess,
    element: <PaymentSuccess />,
  },
  PaymentFailure: {
    path: Paths.PaymentFailure,
    element: <PaymentFailure />,
  },
  GenericError: {
    path: Paths.GenericError,
    element: <GenericError />,
  },
};
